import axios, { AxiosProgressEvent } from 'axios';

const STREAM_URL = `${process.env.REACT_APP_STREAM_URL}/chat/stream`;

export async function testStreamingApi({
  token,
  prompt,
  onChunk,
  onDone
}: {
  token: string;
  prompt: string;
  onChunk: (text: string) => void;
  onDone?: () => void;
}) {
  if (!STREAM_URL) {
    throw new Error('REACT_APP_STREAM_URL is not configured.');
  }

  let processedLength = 0;
  let buffer = '';
  let doneCalled = false;

  const notifyDone = () => {
    if (!doneCalled) {
      doneCalled = true;
      onDone?.();
    }
  };

  await axios.post(
    STREAM_URL,
    {
      systemPrompt: 'You are a concise assistant.',
      prompt,
      max_completion_tokens: 300,
      temperature: 0.2,
      top_p: 0.9
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      responseType: 'text',
      onDownloadProgress: (progressEvent: AxiosProgressEvent) => {
        const xhr = progressEvent.event?.target as XMLHttpRequest | undefined;
        const responseText = xhr?.responseText ?? '';

        const newText = responseText.slice(processedLength);
        processedLength = responseText.length;
        buffer += newText;

        const frames = buffer.split('\n\n');
        buffer = frames.pop() ?? '';

        for (const frame of frames) {
          const dataLine = frame
            .split('\n')
            .find((line) => line.startsWith('data: '));

          if (!dataLine) continue;

          const rawData = dataLine.slice(6).trim();

          if (rawData === '[DONE]') {
            notifyDone();
            continue;
          }

          try {
            const payload = JSON.parse(rawData) as { text?: string };
            if (payload.text) {
              onChunk(payload.text);
            }
          } catch {
            onChunk(rawData);
          }
        }
      }
    }
  );

  notifyDone();
}
